const UrlLive = 'https://www.vishual-ad.my.id'
const UrlDev = process.env.REACT_APP_ENV_DEV //'https://127.0.0.1/grahahermine'
const Url = UrlLive

//const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

export { Url }